export type ArticleBlock = { kind: 'h2' | 'p', text: string }

export type Article = {
    slug: string
    title: string
    category: string
    /** Optional. The date line is hidden when it is empty. */
    date: string
    image: string
    imageAlt: string
    /** Meta description for the article page, 140 to 160 characters. */
    excerpt: string
    body: ArticleBlock[]
}

export const articleAuthor = {
    name: "Bodin's Resort",
    role: 'Washburn, Wisconsin',
    avatar: '/images/boathouse-full-moon.jpg'
}

/** Every post is built from the original site's own wording. */
export const articles: Article[] = [
    {
        slug: 'all-new-cabins-open-all-year',
        title: 'All new cabins, now open all year round',
        category: 'Resort News',
        date: '',
        image: '/images/yellow-cabin-exterior.jpg',
        imageAlt: 'The newly built two level Yellow Cabin among the pines',
        excerpt: "Every rental at Bodin's Resort is new or recently built, with air conditioning, in-floor heat, stocked kitchens and new beds. Now open all year round.",
        body: [
            { kind: 'p', text: 'Our 2026 update: all of our rentals are new or recently built structures. We have been busy upgrading our resort to meet the demands of the seasoned travelers.' },
            { kind: 'p', text: "Air-conditioned units, in-floor heat, fully stocked kitchens and new beds will make you feel at home when you book your stay at Bodin's Resort." },
            { kind: 'h2', text: 'Now open all year round' },
            { kind: 'p', text: "Bodin's Resort is now open all year around, and the Red Cabin is available for long term winter rentals as well." },
            { kind: 'p', text: 'Book your vacation now: check availability online, or call 715-209-7821.' }
        ]
    },
    {
        slug: 'the-all-new-red-cabin',
        title: 'The all new Red Cabin',
        category: 'Cabins',
        date: '',
        image: '/images/red-cabin-kitchen-island.jpg',
        imageAlt: 'Kitchen island and living area under the pine ceiling of the Red Cabin',
        excerpt: 'Built over the winter of 2017, the Red Cabin is our four season cabin on Lake Superior for up to 6 people, close to ice fishing and snowmobile trails.',
        body: [
            { kind: 'p', text: 'Built over the winter of 2017 by Scott Bodin Construction, the all new Red Cabin is our Four Season accommodation for up to 6 people.' },
            { kind: 'h2', text: 'Winter on the shore' },
            { kind: 'p', text: "Guests are just steps away from accessing prime ice-fishing areas off of the shoreline. If you are into snowmobiling, 100's of miles of trails can be reached by a short ride to get onto the trail system." },
            { kind: 'p', text: 'Check out the ice road to Madeline Island, or the Ice Caves when they are open. Or maybe you just want to relax and see how quiet and calm the Winter Season can be.' },
            { kind: 'p', text: 'Check out the local scenes, stores and coffee shops and talk to the locals when they are not in a rush!' },
            { kind: 'h2', text: 'All the amenities' },
            { kind: 'p', text: 'Two bedrooms with queen size beds, a full kitchen and dining room table, a queen sized sofa sleeper and 2 recliners, a three season screened in porch, a full bath with shower and tub, bar counter seating for 3 and a large screen DIRECTV.' },
            { kind: 'p', text: "The cabin is not painted red. A red anchor and red cedar mulch are your signs you've reached the Red Cabin." },
            { kind: 'p', text: 'Make your reservations now by calling 715-209-7821. Available for long term winter rentals as well.' }
        ]
    },
    {
        slug: 'what-to-know-before-you-arrive',
        title: 'What to know before you arrive',
        category: 'Good to Know',
        date: '',
        image: '/images/rocky-shoreline-autumn.jpg',
        imageAlt: 'Rocky Lake Superior shoreline curving toward the pines',
        excerpt: "Check-in after 3pm, check out by 10am, linens provided, pets welcome with a crate, and week long summer stays. What to know before you arrive at Bodin's.",
        body: [
            { kind: 'p', text: "Bodin's Resort has been a vacation destination for families for over 80 years. Here is what you need to know before coming to Bodin's Resort." },
            { kind: 'h2', text: 'Check-in' },
            { kind: 'p', text: 'We welcome you anytime after 3pm. This allows our cleaning staff to get through each cabin and have it ready for you upon your arrival.' },
            { kind: 'h2', text: 'Late arrival' },
            { kind: 'p', text: 'We would like to make your check in go as smoothly as possible. Please let us know if you, or your guests, will be arriving after dark as it can make your check in process a bit more challenging.' },
            { kind: 'h2', text: 'Check out' },
            { kind: 'p', text: 'We ask that you be packed up and out of your cabin by 10am on the morning of your departure.' },
            { kind: 'h2', text: 'Linens' },
            { kind: 'p', text: 'We no longer require that you bring your own linens, including sheets, pillowcases, and towels. We will provide blankets, pillows, and dish towels in the kitchen, and linens for each bed, along with bath towels for each guest.' },
            { kind: 'h2', text: 'Pets' },
            { kind: 'p', text: 'We are a pet friendly facility, however, we would like to know if you are bringing your pets along, this includes dogs or cats. If your animals like to be on the furniture, please bring covers or sheets for the couches and beds. We do require your animal to have a crate so when you are gone they do not get on the furniture, counters or surfaces.' },
            { kind: 'h2', text: 'July and August' },
            { kind: 'p', text: 'To accommodate our returning guests during our peak months of July and August we are looking for week long stays Sunday to Sunday. Please call to book during peak months, as the availability calendar has these months blocked off a full year out to personally manage these requests.' },
            { kind: 'h2', text: 'Cancellation policy' },
            { kind: 'p', text: 'Cancelling a reservation within 30 days of the original reservation start date will forfeit your $200 deposit. Cancelling a reservation 31 days or more before the original reservation start date is fully refundable.' }
        ]
    },
    {
        slug: 'a-note-about-our-beaches',
        title: 'A note about our beaches',
        category: 'Good to Know',
        date: '',
        image: '/images/lake-superior-shoreline.jpg',
        imageAlt: 'Sand and stone beach below the wooded bluff on Lake Superior',
        excerpt: 'Our beaches on Lake Superior change with water levels and wave action, so they may not be as large as some pictures show. Here is what to expect.',
        body: [
            { kind: 'p', text: "Nestled in the trees on the south shore of Lake Superior, Bodin's Resort offers several options for accessing the lake, spacious lawns, fire-pits and a glorious view of the sunrise over the Chequamegon Bay." },
            { kind: 'p', text: "If you aren't an early riser, do not fear, the colors of the sunset reflecting off the waters are just as breathtaking." },
            { kind: 'h2', text: 'Changing water levels' },
            { kind: 'p', text: 'Due to changing water levels and wave action, our beaches may not be as large as some of the pictures show. Please understand that we do not have any control over the ever-changing water levels and the impacts caused by Mother Nature!' }
        ]
    }
]

export const getArticle = (slug: string): Article | undefined =>
    articles.find((article) => article.slug === slug)
